export default "/_next/static/chunks/fonts/IBM Plex Sans Bold-cc85092b6233e3b8ff0acf4d010c4787.ttf";